import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";

import { Drizzle, generateStore } from "./drizzle";
import { DrizzleProvider } from "./drizzle/drizzleContext";
import options from "./drizzle/drizzleOptions";
import { createLogger } from "redux-logger";

import history from './routes/history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { ConnectedRouter } from 'connected-react-router';
import allReducers from './reducers';
import allSagas from './sagas';

import App from "./App";
import LoadingContainer from './drizzle/LoadingContainer';

const appReducers = {
  router: connectRouter(history),
  ...allReducers
};

const appSagas = [
  ...allSagas
]

const logger = createLogger({
  diff: true,
  collapsed: true
});

const store = generateStore({
  drizzleOptions: options,
  appReducers: appReducers,
  appSagas: appSagas,
  //appMiddlewares: [ logger, routerMiddleware(history) ]
  appMiddlewares: [ routerMiddleware(history) ]
});

const drizzle = new Drizzle(options, store);

ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={drizzle.store}>
      <DrizzleProvider drizzle={drizzle}>
        <LoadingContainer>
          <ConnectedRouter history={history}>
            <App history={history}/>
          </ConnectedRouter>
        </LoadingContainer>
      </DrizzleProvider>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
